const resource = '/v1/plans'

export default $axios => ({
  getValidPlans() {
    return $axios.get(`${resource}/list`);
  },
  getUsers() {
    return $axios.get(`${resource}/users`);
  },
  getCurrentPlanWhenPayment() {
    return $axios.get(`${resource}/current-plan`);
  },
  updatePaymentStep(payload) {
    return $axios.put(`${resource}/update-payment-step`, payload);
  },
  changePlan(payload) {
    return $axios.post(`${resource}/change-plan`, payload);
  },
  checkExpired() {
    return $axios.get(`${resource}/check-expired`);
  },
  checkLimit() {
    return $axios.get(`${resource}/check-limit`);
  },
  getTransactionHistory() {
    return $axios.get(`${resource}/transaction-history`);
  },
  generateBill(invoiceId) {
    return $axios.post(`${resource}/generate-bill/${invoiceId}`);
  }
});
